import { render, staticRenderFns } from "./aiNewsMobile.vue?vue&type=template&id=d6220144&scoped=true"
import script from "./aiNewsMobile.vue?vue&type=script&lang=js"
export * from "./aiNewsMobile.vue?vue&type=script&lang=js"
import style0 from "./aiNewsMobile.vue?vue&type=style&index=0&id=d6220144&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6220144",
  null
  
)

export default component.exports